import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { selectGameTurn, selectIsActivePlayer, selectOptions } from '../ActiveGame/selectors';
import { optionReason } from '../ActiveGame/options';
import { selectDrawing } from '../Deck/selectors';
import { draw } from '../Deck/actions';
import { Button } from '../Controls';

/** Every turn starts by drawing a card; there is nothing to undo, so it does not ask first. */
const DrawButton = ({ userId }) => {
  const dispatch = useDispatch();
  const drawing = useSelector(selectDrawing);
  const gameTurn = useSelector(selectGameTurn);
  const isActivePlayer = useSelector((state) => selectIsActivePlayer(state, { userId }));
  const options = useSelector(selectOptions);

  if (!isActivePlayer || !gameTurn || gameTurn.get('drew')) {
    return null;
  }

  // Waiting on the opponent's new active Pokémon, for one; the banner says why.
  const reason = optionReason(options && options.get('draw'));

  return <Button $primary onClick={() => dispatch(draw())} disabled={drawing || !!reason}>Draw a card</Button>;
};

DrawButton.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default DrawButton;
